<template>
  <div id="Soft">
    <div class="softwareContainer">
      <div class="font-title">
        <span>耕地资源智能遥感监测系统</span>
      </div>
      <div class="font-name">登记号：2021SR0877666</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>遥感与GIS集成建筑物监测提取系统</span>
      </div>
      <div class="font-name">登记号：2021SR0959329</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>遥感影像水体要素提取系统</span>
      </div>
      <div class="font-name">登记号：2021SR1124138</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>空天遥感数据一体化准实时处理系统</span>
      </div>
      <div class="font-name">登记号：2019SR1163190</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>遥感影像典型地理要素更新系统</span>
      </div>
      <div class="font-name">登记号：2018SR979651</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>区域空间信息服务与应急指挥系统</span>
      </div>
      <div class="font-name">登记号：2018SR800663</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>GF-3卫星陆表变化检测软件</span>
      </div>
      <div class="font-name">登记号：2017SR504422</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>GF-3卫星水体信息提取软件</span>
      </div>
      <div class="font-name">登记号：2017SR503526</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>GF-3卫星数据管理与自动分类软件</span>
      </div>
      <div class="font-name">登记号：2017SR502530</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>GF-3卫星基本图像处理软件</span>
      </div>
      <div class="font-name">登记号：2017SR506695</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>特定区域变化监测软件</span>
      </div>
      <div class="font-name">登记号：2017SR236971</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>视频与影像快速配准处理专用软件</span>
      </div>
      <div class="font-name">登记号：2017SR210813</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>面向教学平台的遥感影像的判读系统</span>
      </div>
      <div class="font-name">登记号：2015SR231260</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>传感器信息实时接入与加载软件平台</span>
      </div>
      <div class="font-name">登记号：2015SR135890</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>遥感影像与MMS数据融合处理系统</span>
      </div>
      <div class="font-name">登记号：2014SR020853</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>高分辨率SAR遥感信息处理与提供平台</span>
      </div>
      <div class="font-name">登记号：2011SR087058</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>插件式遥感图像处理桌面系统</span>
      </div>
      <div class="font-name">登记号：2011SR086765</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>三维航标配布与仿真系统</span>
      </div>
      <div class="font-name">登记号：2009SR046983</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>三维航道数据处理与可视化系统</span>
      </div>
      <div class="font-name">登记号：2009SR035806</div>
      <el-divider></el-divider>
      <div class="font-title">
        <span>海量多波束水深信息管理与粗差探测系统</span>
      </div>
      <div class="font-name">登记号：2009SR035801</div>
      <el-divider></el-divider>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang='less' scoped>
#Soft {
  margin-top: 20px;
  color: #454545;
  font-size: 14px;
  line-height: 24px;
  .softwareContainer{
    height: 600px;
    overflow-y: scroll;
  }
  .softwareContainer::-webkit-scrollbar {
    width: 6px;
  }
  .softwareContainer::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(208, 208, 208, 0.4);
  }
  .font-title {
    // font-family: "Times New Roman", Times, serif;
    font-weight: bold;
  }
  // .font-name {
  //   font-family: "Times New Roman", Times, serif;
  // }
}
</style>
